import { LitElement, mailcheck } from '@hh/global.js'

class OmetriaNewsletter extends LitElement {
  constructor() {
    super()
    this.form = this.querySelector('form')
    if (!this.form) return
    this.form.addEventListener('submit', this.submitForm.bind(this))

    this.submitButton = this.querySelector('[type="submit"]')
    this.successBanner = this.querySelector('.js-success-banner')
    this.errorBanner = this.querySelector('.js-error-banner')
    this.emailSuggestion = this.querySelector('.js-email-suggestion')
  }

  connectedCallback() {
    this.validateStatus()
  }

  validateStatus() {
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get('origin') === 'newsletter-form' && urlParams.get('ometria_form_ok') === 'Y') {
      this.showSuccess()
      window.location.href = '#OmetriaNewsletterForm'
      window.history.pushState({}, null, `${window.location.origin}${window.location.pathname}`)
    }
  }

  submitForm(evt) {
    evt.preventDefault()
    this.hideStatus()
    this.submitButton?.setAttribute('disabled', true)
    const email = this.form.querySelector('[name="ue"]').value

    mailcheck.run({
      email,
      suggested: (suggestion) => {
        this.emailSuggestion.querySelector('.js-email').innerHTML = `${suggestion.address}@<strong>${suggestion.domain}</strong>`
        this.emailSuggestion.removeAttribute('hidden')
      },
      empty: () => {
        this.createSubscription()
      }
    })
  }

  async createSubscription() {
    this.form.submit()
  }

  showSuccess() {
    this.successBanner?.removeAttribute('hidden')
  }

  showError() {
    this.errorBanner?.removeAttribute('hidden')
  }

  hideStatus() {
    this.successBanner?.setAttribute('hidden', true)
    this.errorBanner?.setAttribute('hidden', true)
    this.emailSuggestion?.setAttribute('hidden', true)
  }
}

customElements.define('hh-ometria-newsletter', OmetriaNewsletter)
